import { Fragment } from "react";

import { Icon } from "./Icon";
import { cn } from "./cn";

interface StepperProps {
  steps: string[];
  current: number;
}

export function Stepper({ steps, current }: StepperProps) {
  return (
    <div className="flex items-center w-full">
      {steps.map((label, i) => {
        const state = i < current ? "done" : i === current ? "current" : "future";
        return (
          <Fragment key={label}>
            <div className="flex items-center gap-2 shrink-0">
              <div
                className={cn(
                  "w-[26px] h-[26px] rounded-full font-mono font-bold text-xs grid place-items-center border-[1.5px]",
                  state === "done" && "bg-ink text-bg border-transparent",
                  state === "current" && "bg-accent text-on-accent border-transparent",
                  state === "future" && "bg-surface text-sub border-line-strong",
                )}
              >
                {state === "done" ? <Icon name="check" size={13} /> : i + 1}
              </div>
              <div
                className={cn(
                  "font-display text-[13px] uppercase tracking-[-0.005em]",
                  state === "current" && "font-extrabold text-ink",
                  state === "future" && "text-sub font-semibold",
                  state === "done" && "text-ink font-semibold",
                )}
              >
                {label}
              </div>
            </div>
            {i < steps.length - 1 && (
              <div
                className={cn(
                  "flex-1 h-[2px] mx-[14px] min-w-[16px]",
                  i < current ? "bg-ink" : "bg-line-strong",
                )}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
